export default __webpack_public_path__ + "static/serverless-vantaggi-svantaggi-7f688159f6218bef9cc040d084ef398b.jpg";